import { formatDateColumn } from '@vindr/utils/dateTime';
import { ColumnType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';

interface CreateAtColumnProps extends ColumnType<any> {
  showTime?: boolean;
  type?: 'created_at' | 'updated_at';
}

const Type = {
  created_at: {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
  },
  updated_at: {
    title: 'Updated At',
    dataIndex: 'updated_at',
    key: 'updated_at',
  },
};

const DateColumn = ({
  title,
  dataIndex,
  width = 140,
  key,
  sorter = true,
  showTime = true,
  type,
  ...props
}: CreateAtColumnProps) => {
  const { t } = useTranslation('Vindoc');

  return {
    title: t(title || Type[type]?.title),
    dataIndex: dataIndex || Type[type].dataIndex,
    key: key || Type[type].key,
    width,
    sorter,
    render: (text) => formatDateColumn(text, showTime),
    ...props,
  };
};

export default DateColumn;
